import React, { useState, useEffect, useContext } from 'react';
import { useMediaQuery } from 'react-responsive';
import PulseLoader from "react-spinners/PulseLoader";

import {AuthContext} from "../contexts/AuthContext";
import DeviceChart from "./DeviceChart"
import { DeviceType, TimeRange, ListDevicesRequest } from "../goveepb/internal/proto/govee_pb"
import { GoveeUIClient } from "../goveepb/internal/proto/govee_grpc_web_pb"
import {ZoomContext} from "../contexts/ZoomContext";
import useGrpcWithAuth from "../hooks/useGrpcWithAuth";

const DeviceList = () => {
  const [devices, setDevices] = useState([]);
  const [isLoadingDevices, setIsLoadingDevices] = useState(true);
  const [errClassName, setErrClassName] = useState("err-message-hide");
  const [errMessage, setErrMessage] = useState(null);
  const { user, isLoadingUser } = useContext(AuthContext);
  const { since, until, setCustomTimeRange } = useContext(ZoomContext);
  const callWithRetry = useGrpcWithAuth();

  const client = new GoveeUIClient(process.env.REACT_APP_GRPC_URL);
  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 1124px)'
  });

  const fetchDevices = () => {
    console.log("fetching device list");
    if (isLoadingUser) {
      return;
    }

    if (!user) {
      setIsLoadingDevices(false);
      return;
    }

    const req = new ListDevicesRequest();
    req.setType(DeviceType.GOVEE);
    req.setTimerange(new TimeRange([since, until]));
    console.log("Fetching list of devices with timeRange", new Date(since), new Date(until));

    callWithRetry(
      (metadata, cb) => client.listDevices(req, metadata, cb),
      (err, response) => {
        if (err) {
          console.error("Received error getting batch of devices", err);
          var message = "An error occurred loading the list of Govee devices";
          if (err && err.message) {
            message += ': "' + err.message + '"';
          }
          message += ". Will retry automatically."
          setErrMessage(message);
          setErrClassName("err-message-show");
          setIsLoadingDevices(false);
        } else {
          const devicesList = response.getDevicesList();
          console.log("Received fresh batch of devices:", devicesList.length)
          setErrClassName("err-message-hide")
          setDevices(devicesList);
          setIsLoadingDevices(false);
        }
      }
    );
  }

  useEffect(() => {
    if (isLoadingUser) {
      return;
    }

    console.log("DeviceList: use effect, about to fetch Devices")
    fetchDevices();
  }, [user, isLoadingUser, since, until]);

  const onDragZoom = (left, right) => {
    console.log("onDragZoom, setting custom time range", new Date(left), new Date(right));
    setCustomTimeRange(left, right, "Custom");
  };

  const charts = devices.map((device, index) => {
    return (
        <li className="device-list-entry" key={device.getId()}>
          <DeviceChart key={device.getId()} client={client} device={device} onDragZoom={onDragZoom} showExpand={true}/>
        </li>
    );
  });

  if (isLoadingUser || isLoadingDevices) {
    return (
        <>
          <div className={errClassName}>{errMessage}</div>
          <div className="device-list">
            <ul>
              <li className="device-list-empty-state">
                <PulseLoader speedMultiplier={0.8} color="#629af0"/>
              </li>
            </ul>
          </div>
        </>
    );
  }

  return (
      <>
        <div className={errClassName}>{errMessage}</div>
        <div className="device-list">
          <ul>
            {user && charts.length > 0 && charts}
            {user && charts.length === 0 && (
                <li className="device-list-empty-state">No Govee temperature sensors found</li>
            )}
          </ul>
        </div>
      </>

  );
};

export default DeviceList;
